export const END_PROXY_ACTION = 'modal/END_PROXY_ACTION';
